import { createSelector } from 'reselect';
import { MEDIA_QUERY_MAP } from 'reducers/ui';

const selectUI = state => state.ui || {};

export const selectNavIsOpen = createSelector(selectUI, ui => ui.navIsOpen);

const XS_BREAKPOINTS = Object.keys(MEDIA_QUERY_MAP).reverse(); // ['xs', 'sm', 'md', 'lg', 'xl']
const SM_BREAKPOINTS = XS_BREAKPOINTS.slice(1);
const MD_BREAKPOINTS = SM_BREAKPOINTS.slice(1);
const LG_BREAKPOINTS = MD_BREAKPOINTS.slice(1);
const XL_BREAKPOINTS = LG_BREAKPOINTS.slice(1);

export const selectPageIsVisible = createSelector(selectUI, ui => ui.foreground);
export const selectIsXS = createSelector(selectUI, ui => XS_BREAKPOINTS.includes(ui.breakpoint));
export const selectIsSM = createSelector(selectUI, ui => SM_BREAKPOINTS.includes(ui.breakpoint));

export const selectIsMD = createSelector(selectUI, ui => MD_BREAKPOINTS.includes(ui.breakpoint));

export const selectIsMobile = createSelector(selectUI, ui => !MD_BREAKPOINTS.includes(ui.breakpoint));

const selectIsLG = createSelector(selectUI, ui => LG_BREAKPOINTS.includes(ui.breakpoint));
const selectIsDesktop = selectIsLG;
export { selectIsLG, selectIsDesktop };

export const selectIsXL = createSelector(selectUI, ui => XL_BREAKPOINTS.includes(ui.breakpoint));
export const selectViewportWidth = createSelector(selectUI, ({ viewportWidth }) => viewportWidth);

export const selectUIState = state => ({
  viewportWidth: selectViewportWidth(state),
  xs: selectIsXS(state),
  sm: selectIsSM(state),
  md: selectIsMD(state),
  lg: selectIsLG(state),
  xl: selectIsXL(state),
});
